export default __webpack_public_path__ + "static/media/pakrap-7.d22d1ed2.mp3";